import {useSelector} from 'react-redux';

export default function useIsMobile() {
  return useSelector((state) => state?.browser?.is?.small || state?.browser?.lessThan?.small);
}
